import React from 'react';

import type { HTMLAttributes } from 'types';
import { cn } from 'utils/classNames';

export type BadgeSize = 'sm' | 'md';

export interface Props extends HTMLAttributes<HTMLSpanElement> {
	className?: string;
	size?: BadgeSize;
	text: string | number | undefined;
}

/** A number as a rounded badge. */
export default function Badge({
	className,
	size = 'md',
	text,
	...attrs
}: Props) {
	if (text === '' || text === undefined) {
		return null;
	}

	return (
		<span
			{...attrs}
			className={cn(
				className,
				'inline-flex shrink-0 items-center justify-center rounded-full',
				'font-body font-bold',
				'bg-badge text-inverse',
				'outline outline-inverse forced-colors:outline-1',
				size === 'sm' && 'h-4 min-w-4 px-1 text-xs outline-1',
				size === 'md' && 'h-5 min-w-5 px-1.5 text-sm outline-2',
			)}
		>
			{text}
		</span>
	);
}
Badge.displayName = 'Badge';
